<template>
  <div class="p-fluid" style="direction: rtl">
    <div class="card p-d-flex p-jc-center">
      <DataTable
              :exportFilename="`דוח נוכחות - ${new Date().toLocaleString() }`"

              sortMode="multiple"
        removableSort
        ref="presenceTable"
        :rowClass="rowClass"
        :value="data"
        :paginator="isPaginatorShow"
        :selection.sync="selectedItemsPresence"
        :resizableColumns="false"
        @cell-edit-complete="onCellEditComplete"
        columnResizeMode="fit"
        dataKey="id"
        class="
          p-datatable-customers
          p-datatable-sm
          p-datatable-gridlines
          p-datatable-striped
        "
        :rows="50"
        stateStorage="session"
        stateKey="presence-data-state"
        editMode="cell"
        :filters="filters"
        :loading="loading"
        sortField="grade.hebrewName"
        :sortOrder="1"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        :rowsPerPageOptions="[20, 50, 200, 1000]"
        currentPageReportTemplate="מציג {first} עד {last} מתוך {totalRecords}"
      >
        <!-- header -->

        <template #header>
          <div class="p-p-2 table-header">
            <div class="p-m-1 p-d-inline-flex">
              <h1 style="text-align: center">
                <i
                  style="transform: scale(1.7)"
                  class="p-p-3 pi pi-calendar-minus"
                ></i
                >| נוכחות תלמידים
              </h1>
            </div>

            <div class="p-d-flex">
              <span class="p-mr-2 p-input-icon-left">
                <i class="pi pi-search" />
                <InputText
                  v-model="filters['global']"
                  placeholder="חיפוש ראשי"
                />
              </span>
                <Button
                        v-tooltip.top="'ייצוא טבלה'"
                        class="p-mr-2 p-button-warning"
                        icon="pi pi-download"
                        @click="exportCSV($event)"
                />
              <Button
                v-tooltip.top="'מחיקה'"
                v-if="
                  selectedItemsPresence.length > 0 &&
                  selectedItemsPresence.length < 5
                "
                icon="pi pi-trash"
                class="p-mr-2 p-button-danger"
                @click="isDialogDelete = true"
              />
              <Button
                v-tooltip.top="'ניתן למחוק\n רק עד 5 פריטים'"
                v-if="selectedItemsPresence.length >= 5"
                icon="pi pi-trash"
                class="p-mr-2 p-button-secondary"
              />
              <Button
                v-tooltip.top="'הוספה'"
                icon="pi pi-plus"
                class="p-mr-2 p-button-success"
                @click="isDialogAdd = true"
              />
            </div>
          </div>
        </template>
        <template #loading> טוען נתונים מהמערכת, אנא המתן...</template>
        <Column selectionMode="multiple" headerStyle="width: 3em"></Column>

        <!-- pupils -->

        <Column
          headerStyle="text-align: rtl"
          bodyStyle="text-align: right;"
          field="pupil"
          header="תלמיד"
          filterMatchMode="in"
          filterField="pupil"
          sortable
          sortField="pupil.lastname"
        >
          <template #filter>
            <MultiSelect
              filterPlaceholder=" חפש לפי שם משפחה"
              emptyFilterMessage=" לא נמצא שם משפחה תואם"
              :showClear="true"
              :filter="true"
              dataKey="id"
              optionLabel="lastname"
              v-model="filters['pupil']"
              :options="pupils"
              placeholder="סנן לפי תלמיד"
            >
              <template #option="slotProps">
                <span
                  >{{ slotProps.option.grade?.hebrewName }}:
                  {{ slotProps.option?.firstname }}
                  {{ slotProps.option?.lastname }}</span
                >
              </template>
              <template #value="slotProps">
                <div v-if="!slotProps.value || slotProps.value.length === 0">
                  {{ slotProps.placeholder }}
                </div>
                <span v-else>
                  <span v-for="(a, index) in slotProps.value" :key="index">
                    {{ a.grade?.hebrewName }}: {{ a?.firstname }}
                    {{ a?.lastname }},
                  </span>
                </span>
              </template>
            </MultiSelect>
          </template>

          <template #editor="slotProps">
            <Dropdown
              filterPlaceholder=" חפש לפי שם משפחה"
              emptyFilterMessage=" לא נמצא שם משפחה תואם"
              :filter="true"
              optionLabel="lastname"
              dataKey="id"
              :value="slotProps.data[slotProps.column.field]"
              :options="pupils"
              placeholder="בחר תלמיד"
              @input="onCellEdit($event, slotProps)"
            >
              <template #value="slotProps">
                <div v-if="!slotProps.value || slotProps.value.length === 0">
                  {{ slotProps.placeholder }}
                </div>
                <span v-else>
                  {{ slotProps.value.firstname }} {{ slotProps.value.lastname }}
                </span>
              </template>
              <template #option="slotProps">
                <span
                  >{{ slotProps.option.grade.hebrewName }}:
                  {{ slotProps.option.firstname }}
                  {{ slotProps.option.lastname }}</span
                >
              </template>
            </Dropdown>
          </template>

          <template #body="slotProps">
            <div>
              {{ slotProps.data.pupil.firstname }}
              {{ slotProps.data.pupil.lastname }}
            </div>
          </template>
        </Column>

        <!-- time -->

        <Column
          headerStyle="text-align: rtl"
          bodyStyle="text-align: right;"
          field="time"
          header="שיעור"
          filterMatchMode="in"
          filterField="time"
          sortable
          sortField="time.hebrewName"
        >
          <template #filter>
            <MultiSelect
              v-model="filters['time']"
              :options="lessonTime"
              :showClear="true"
              placeholder="סנן לפי שיעור"
              class="multiselect-custom"
            >
              <template #option="slotProps">
                <span>{{ slotProps.option.hebrewName }}</span>
              </template>
              <template #value="slotProps">
                <div v-if="!slotProps.value || slotProps.value.length === 0">
                  {{ slotProps.placeholder }}
                </div>
                <span v-else>
                  <span v-for="(a, index) in slotProps.value" :key="index">
                    {{ a.hebrewName }},
                  </span>
                </span>
              </template>
            </MultiSelect>
          </template>

          <template #editor="slotProps">
            <Dropdown
              :value="slotProps.data[slotProps.column.field]"
              :options="lessonTime"
              placeholder="בחר שיעור"
              @input="onCellEdit($event, slotProps)"
            >
              <template #value="slotProps">
                <div v-if="!slotProps.value || slotProps.value.length === 0">
                  {{ slotProps.placeholder }}
                </div>
                <span v-else> {{ slotProps.value.hebrewName }} </span>
              </template>
              <template #option="slotProps">
                <span> {{ slotProps.option.hebrewName }}</span>
              </template>
            </Dropdown>
          </template>

          <template #body="slotProps">
            <div>
              {{ slotProps.data.time.hebrewName }}
            </div>
          </template>
        </Column>

        <!-- status -->

        <Column
          headerStyle="text-align: rtl"
          bodyStyle="text-align: right;"
          field="status"
          header="מצב נוכחות"
          filterMatchMode="in"
          filterField="status"
          sortable
          sortField="status.hebrewName"
        >
          <template #filter>
            <MultiSelect
              v-model="filters['status']"
              :options="presenceStatus"
              :showClear="true"
              placeholder="סנן לפי סוג"
              class="multiselect-custom"
            >
              <template #option="slotProps">
                <span>{{ slotProps.option.hebrewName }}</span>
              </template>
              <template #value="slotProps">
                <div v-if="!slotProps.value || slotProps.value.length === 0">
                  {{ slotProps.placeholder }}
                </div>
                <span v-else>
                  <span v-for="(a, index) in slotProps.value" :key="index">
                    {{ a.hebrewName }},
                  </span>
                </span>
              </template>
            </MultiSelect>
          </template>

          <template #editor="slotProps">
            <Dropdown
              :value="slotProps.data[slotProps.column.field]"
              :options="presenceStatus"
              placeholder="בחר סוג"
              @input="onCellEdit($event, slotProps)"
            >
              <template #value="slotProps">
                <div v-if="!slotProps.value || slotProps.value.length === 0">
                  {{ slotProps.placeholder }}
                </div>
                <span v-else> {{ slotProps.value.hebrewName }} </span>
              </template>
              <template #option="slotProps">
                <span> {{ slotProps.option.hebrewName }}</span>
              </template>
            </Dropdown>
          </template>

          <template #body="slotProps">
            <div :style="{'background-color':  slotProps.data.status.color}">
              {{ slotProps.data.status.hebrewName }}
            </div>
          </template>
        </Column>

        <!-- date -->

        <Column
          headerStyle="text-align: rtl"
          bodyStyle="text-align: right;"
          field="date"
          header="תאריך"
          filterMatchMode="custom"
          :filterFunction="filterDate"
          filterField="date"
          sortable
          sortField="date"
        >
          <template #filter>
            <Calendar
              :touchUI="true"
              :showButtonBar="true"
              dateFormat="dd.mm.yy"
              selectionMode="range"
              v-model="filters['date']"
              placeholder="סנן לפי תאריך"
            />
          </template>

          <template #editor="slotProps">
            <Calendar
              :touchUI="true"
              :showButtonBar="true"
              dateFormat="dd.mm.yy"
              id="basic"
              :value="new Date(slotProps.data[slotProps.column.field])"
              @input="onCellEdit($event, slotProps)"
            />
          </template>

          <template #body="slotProps">
            <div>
              {{
                new Date(slotProps.data.date).toLocaleDateString().split("T")[0]
              }}
            </div>
          </template>
        </Column>

        <!-- user -->

        <Column
          headerStyle="width: 8%; text-align: rtl"
          bodyStyle="text-align: right; color: #0000004C;"
          field="user"
          header="מורה מדווח"
          filterField="user"
          filterMatchMode="custom"
          :filterFunction="filterTeacher"
          sortable
          sortField="user.lastname"
        >
          <template #filter>
            <MultiSelect
              filterPlaceholder=" חפש לפי שם משפחה"
              emptyFilterMessage=" לא נמצא שם משפחה תואם"
              :filter="true"
              :showClear="true"
              dataKey="id"
              :options="teachers"
              v-model="filters['user']"
              optionLabel="lastname"
              placeholder="סנן לפי מורה"
            >
              <template #option="slotProps">
                <span>
                  {{ slotProps.option.firstname }}
                  {{ slotProps.option.lastname }}</span
                >
              </template>
              <template #value="slotProps">
                <div v-if="!slotProps.value || slotProps.value.length === 0">
                  {{ slotProps.placeholder }}
                </div>
                <span v-else>
                  <span v-for="(a, index) in slotProps.value" :key="index">
                    {{ a.firstname }}
                    {{ a.lastname }},
                  </span>
                </span>
              </template>
            </MultiSelect>
          </template>

          <template #body="slotProps">
            <div>
              {{ slotProps.data.user.firstname }}
              {{ slotProps.data.user.lastname }}
            </div>
          </template>
        </Column>

        <!-- grade -->
        <Column
          headerStyle="width: 8%; text-align: rtl"
          bodyStyle="text-align: right;  color: #0000004C;"
          field="grade"
          header="כיתה"
          filterMatchMode="in"
          filterField="grade"
          sortable
          sortField="grade.hebrewName"
        >
          <template #filter>
            <MultiSelect
              filterPlaceholder=" חפש לפי שם כיתה"
              emptyFilterMessage=" לא נמצא שם כיתה תואם"
              :filter="true"
              dataKey="id"
              optionLabel="hebrewName"
              v-model="filters['grade']"
              :options="gradeOptions"
              :showClear="true"
              placeholder="סנן לפי כיתה"
            >
              <template #option="slotProps">
                <span>{{ slotProps.option.hebrewName }}</span>
              </template>
              <template #value="slotProps">
                <div v-if="!slotProps.value || slotProps.value.length === 0">
                  {{ slotProps.placeholder }}
                </div>
                <span v-else>
                  <span v-for="(a, index) in slotProps.value" :key="index">
                    {{ a.hebrewName }},
                  </span>
                </span>
              </template>
            </MultiSelect>
          </template>

          <template #body="slotProps">
            <div>
              {{ slotProps.data.grade.hebrewName }}
            </div>
          </template>
        </Column>

        <template #footer>
          סה״כ {{ data ? data.length : 0 }} משתמשים.
        </template>
      </DataTable>
    </div>

    <add-Dialog
      :show="isDialogAdd"
      v-on:addItem="addItem"
      v-on:closeDialog="isDialogAdd = false"
    >
    </add-Dialog>
    <delete-dialog
      :title="'מחיקת משתמש'"
      :context="`האם תרצה להסיר  ${selectedItemsPresence.length}   משתמשים מהמערכת?`"
      :show="isDialogDelete"
      v-on:choice="deleteItem"
    >
    </delete-dialog>
  </div>
</template>

<script>
import AddDialog from "../../dialogs/mainPost/PresenceDialog";
import deleteDialog from "../../dialogs/DeleteDialog.vue";
import Service from "../../service/Service";
import Vue from "vue";
import { mapState } from "vuex";

export default {
  service: null,
  components: {
    AddDialog,
    deleteDialog,
  },
  created() {
    this.service = new Service();
    setTimeout(() => {
      this.selectedItemsPresence = [];
    }, 500);
    this.service.get(this.ENTITY).then((data) => {
      data.forEach((element) => {
        element.pupil = this.getPupilObj(element.pupil);
        element.time = this.getTimeObj(element.time);
        element.status = this.getStatusObj(element.status);
        element.user = this.getUserObj(element.user);
        element.grade = element.pupil?.grade;
        if (!element.pupil) {
          element.pupil = {};
        }
        if (!element.grade) {
          element.grade = {};
        }
      });
      this.data = data;
      this.loading = false;
    });
  },
  mounted() {
      this.filters = {}
      if (this.$route.query.pupil) {
          this.filters = {
              ...this.filters,
              pupil: [this.getPupilObj(this.$route.query.pupil)],
          }
      }
      if (this.$route.query.status) {
          this.filters = {
              ...this.filters,
              status: [this.getStatusObj(this.$route.query.status)],
          }
      }
      if (this.$route.query.start && this.$route.query.end) {
          const start = parseInt(this.$route.query.start)
          const end = parseInt(this.$route.query.end)
          this.filters = {
              ...this.filters,
              date: [new Date(start),new Date(end)],
          }
      }
  },
  data() {
    return {
      ENTITY: "presence",
      data: null,
      loading: true,
      isDialogDelete: false,
      isDialogAdd: false,
      selectedItemsPresence: [],
      filters: {},
      itemBeforeEditing: {},
      itemAfterEditing: {},
      enabled: [true, false],
    };
  },
  computed: {
    isPaginatorShow() {
      return (
        this.filters && // 👈 null and undefined check
        Object.keys(this.filters).length === 0 &&
        Object.getPrototypeOf(this.filters) === Object.prototype
      );
    },
    ...mapState([
      "pupils",
      "teachers",
      "gradeOptions",
      "user",
      "lessonTime",
      "presenceStatus",
    ]),
  },
  methods: {
    getPupilObj(pupilId) {
      return this.pupils.find((pupil) => pupil.id === pupilId);
    },
    getTimeObj(timeId) {
      return this.lessonTime.find((lessonTime) => lessonTime.id === timeId);
    },
    getStatusObj(statusId) {
      return this.presenceStatus.find(
        (presenceStatus) => presenceStatus.id === statusId
      );
    },
    getUserObj(userId) {
      return this.teachers.find((teacher) => teacher.id === userId);
    },
    filterDate(value, filter) {
      if (
        filter === undefined ||
        filter === null ||
        (typeof filter === "string" && filter.trim() === "")
      ) {
        return true;
      }

      if (value === undefined || value === null) {
        return false;
      }

      if (filter[1] !== null) {
        return value >= Date.parse(filter[0]) && value <= Date.parse(filter[1]);
      } else if (filter[1] === null) {
        const a = new Date(value);

        a.setDate(a.getDate() - 1);

        return a.getTime() === filter[0].getTime();
      }
      // return true;
    },
    getTime(timerId) {
      return this.lessonTime.find((lTime) => lTime.id === timerId);
    },
    rowClass(data) {
      return data.enabled === false ? "row-unenabled" : null;
    },

    addItem(item) {
      this.data.push(item);
    },
    deleteItem(choice) {
      this.isDialogDelete = false;
      if (choice) {
        this.loading = true;

        const itemsIds = [];
        const selscteds = this.selectedItemsPresence;
        this.selectedItemsPresence.forEach((item) => {
          itemsIds.push(item.id);
        });

        this.service
          .deleteMany(itemsIds, this.ENTITY)
          .then(() => {
            this.loading = false;
            this.openNotification(
              "success",
              `מעולה`,
              `מחקנו ${itemsIds.length}  רשומות מהמערכת`
            );
            selscteds.forEach((selected) => {
              this.data = this.data.filter((item) => item.id !== selected.id);
            });
          })
          .catch(() => {
            this.loading = false;
            this.openNotification(
              "danger",
              `אופס`,
              `לא הצלחנו למחוק את הרשומות מהמערכת`
            );
            this.data.push(...this.selectedItemsPresence);
            this.selectedItemsPresence = [];
          });

        this.isDialogDelete = false;
      }
      this.selectedItemsPresence = [];
    },

    async onCellEditComplete(event) {
      const index = this.data.findIndex(
        (item) => item.id === this.itemAfterEditing.id
      );
      this.data[index] = this.itemAfterEditing;

      Vue.set(this.data, index, this.itemAfterEditing);
      const clone = JSON.parse(JSON.stringify(this.itemAfterEditing));
      clone.pupil = this.itemAfterEditing.pupil.id;
      clone.status = this.itemAfterEditing.status.id;
      clone.time = this.itemAfterEditing.time.id;
      clone.date = this.itemAfterEditing.date;

      clone.grade = this.itemAfterEditing.grade.id;
      clone.user = this.itemAfterEditing.user.id;

      this.service
        .update(clone, this.ENTITY)
        .then(() => {})
        .catch(() => {
          Vue.set(this.data, index, this.itemBeforeEditing);
          this.openNotification(
            "danger",
            `אופס`,
            `קרתה תקלה בעדכון הנתונים במערכת`
          );
        });
    },
    onCellEdit(newValue, props) {
      this.itemBeforeEditing = { ...props.data };
      this.itemAfterEditing = { ...props.data };
      this.itemAfterEditing[props.column.field] = newValue;
    },
      exportCSV() {
          this.$refs.presenceTable.exportCSV({convertData: this.convertData});
      },
      convertData(data, field) {
          switch (field) {
              case "date":
                  return new Date(data)?.toLocaleDateString()
              case "time":
              case "grade":
              case "status":
                  return data && data.hebrewName
              case "teacher":
              case "pupil":
              case "user":
                  return `${data?.lastname} ${data?.firstname}`
              default:
                  return data
          }
      },
    filterTeacher(value, filter) {
      if (
        filter.length === 0 ||
        filter === undefined ||
        filter === null ||
        (typeof filter === "string" && filter.trim() === "")
      ) {
        return true;
      }

      if (value === undefined || value === null) {
        return false;
      }
      let isExist = false;
      filter.forEach((filter) => {
        if (filter.id === value.id) {
          isExist = true;
        }
      });
      return isExist;
    },
    getRoleLabel(status) {
      switch (status) {
        case "ADMIN":
          return "מנהל";

        case "USER":
          return "מחנך";

        case "MIKTZOI":
          return "מקצועי";

        default:
          return "NA";
      }
    },
    getEnabledLabel(boolean) {
      switch (boolean) {
        case true:
          return "פעיל";

        case false:
          return "לא פעיל";

        default:
          return "NA";
      }
    },
    openNotification(
      color,
      title,
      text,
      position = "right-left",
      duration = 3000
    ) {
      this.$vs.notification({
        color,
        position,
        title,
        text,
        duration,
        progress: "auto",
      });
    },
  },
};
</script>


<style scoped>
</style>